import React, { useEffect, useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../utils/BaseUrl";
import { useParams } from "react-router-dom";
import CircleLoading from "../../../common/Loading/CircleLoading";
import SpinerLoading from "../../../common/Loading/SpinerLoading";
import TraingleLoading from "../../../common/Loading/TraingleLoading";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ManditoryStar from "../../templates/ManditoryStar";

const ChatBotForm = () => {
  const [faqData, setFaqData] = useState({
    question: "",
    answer: "",
    category: "",

    questionStatus: "unchecked",
    answerStatus: "unchecked",
    categoryStatus: "unchecked",
  });
  const navigate = useNavigate();

  const categoryOption = ["Career", "Service", "Faq"];
  const { id } = useParams();

  const { data,isLoading } = useQuery({
    queryKey: "getsingleFaq",
    queryFn: () =>
      axios.get(`${BASEURL}faq/${id}`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      setFaqData({
        question: response?.question,
        answer: response?.answer,
        category: response?.category,

        questionStatus: "success",
        answerStatus: "success",
        categoryStatus: "success",
      });
    },
  });

  const handleChange = (e) => {
    let newdata = { ...faqData };

    if (e?.target?.name == "question") {
      const allCharactersLengthRegex = new RegExp("^.{3,1000}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "answer") {
      const allCharactersLengthRegex = new RegExp("^.{2,5000}$", "s");;
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e?.target?.name == "category") {
      const allCharactersLengthRegex = new RegExp("^.{1,15}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }
    newdata[e.target.name] = e.target.value;
    setFaqData(newdata);
  };
  const checkSubmit = () => {
    let status = true;

    if (
      faqData.answerStatus == "success" &&
      faqData.questionStatus == "success" &&
      faqData.categoryStatus == "success"
    ) {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}faq`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "FAQ Created Successfully.",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/faq");
      });
    },
  });
  const editMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}faq/${id}`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "FAQ updated Successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate("/admin/faq");
      });
    },
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    const values = {
      question: faqData.question,
      answer: faqData.answer,
      category: faqData.category,
    };
    mutation.mutate(values);
  };
  const handleEdit = (e) => {
    e.preventDefault();
    const values = {
      question: faqData.question,
      answer: faqData.answer,
      category: faqData.category,
    };
    editMutation.mutate(values);
  };
  return (
    <div>
      <AdminTabelHeader title={id ? "Edit FAQ" : "Add FAQ"} btnStatus={false} />
      {(mutation.isLoading || editMutation.isLoading) && <TraingleLoading />}
      {
        (id &&  isLoading) && <TraingleLoading />
      }

      <div className="p-4">
        <div className="grid grid-cols-1 gap-4">
          <div>
            <ManditoryStar title={"Question"} />

            <input
              name="question"
              value={faqData.question}
              className={`input ${
                faqData.questionStatus == "success"
                  ? "input-success"
                  : faqData.questionStatus == "error"
                  ? "input-error"
                  : ""
              }`}
              type="text"
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <ManditoryStar title={"Answer"} />
            <textarea
              value={faqData.answer}
              name="answer"
              className={`textarea ${
                faqData.answerStatus == "success"
                  ? "input-success"
                  : faqData.answerStatus == "error"
                  ? "input-error"
                  : ""
              }`}
              onChange={(e) => handleChange(e)}
            />
          </div>

          <div>
            <ManditoryStar title={"Category"} />

            <select
              name="category"
              value={faqData.category}
              onChange={(e) => handleChange(e)}
              className={`input ${
                faqData.categoryStatus == "success"
                  ? "input-success"
                  : faqData.categoryStatus == "error"
                  ? "input-error"
                  : ""
              }`}
            >
              <option value="">Select Category</option>
              {categoryOption?.map((v, i) => (
                <option key={i} value={v}>
                  {v}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-end my-4 ">
        <button
            onClick={() => navigate(-1)}
            // disabled={checkSubmit()}
            className={"formSubmit mr-8 cursor-pointer "}
          >
            Cancel
          </button>
          <button
            onClick={id ? (e) => handleEdit(e) : (e) => handleSubmit(e)}
            disabled={checkSubmit()}
            className={`formSubmit ${
              checkSubmit() ? "cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            {id ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatBotForm;
